import { useMemo } from 'react';
import { Page, Text, View, Document, Link } from '@react-pdf/renderer';
import Icon from '../../assets/icons/social_midias/pdf_icons_model';
import { createStyles } from './ResumePdfModels.styles';

const CurriculoPDF = ({ formData, color = '#60B70C' }) => {
    const styles = useMemo(() => createStyles(color), [color]);

    const shortenUrl = (url) => {
        try {
            return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, '');
        } catch (error) {
            return url;
        }
    };

    return (
        <Document>
            <Page size="A4" style={styles.body}>
                <View style={styles.leftColumn}>
                    <View style={styles.headerLeft}>
                        <View style={styles.nome}>
                            {formData.dadosPessoais.nome.split(' ').map((palavra, index) => (
                                <Text key={index}>
                                    {palavra}
                                </Text>
                            ))}
                        </View>
                        <Text style={styles.contato}>{formData.dadosPessoais.email}</Text>
                        <Text style={styles.contato}>{formData.dadosPessoais.telefone}</Text>
                        <Text style={styles.contato}>{`${formData.dadosPessoais.municipio} - ${formData.dadosPessoais.bairro}`}</Text>
                    </View>
                    <View style={styles.sectionLeft}>
                        <Text style={styles.titleLeft}>Sobre Mim</Text>
                        <Text>{formData.dadosPessoais.sobreMim}</Text>
                    </View>
                    <View style={styles.sectionLeft}>
                        <Text style={styles.titleLeft}>Redes Sociais</Text>
                        {Object.entries(formData.dadosPessoais.redesSociais).map(([key, value]) =>
                            value ? (
                                <View key={key} style={styles.socialItem}>
                                    <View style={styles.socialIcon}>
                                        <Icon name={key} style={styles.socialIcon} />
                                    </View>
                                    <Link src={value} style={styles.socialLink}>
                                        {shortenUrl(value)}
                                    </Link>
                                </View>
                            ) : null
                        )}
                    </View>
                </View>

                <View style={styles.rightColumn}>
                    <View style={styles.sectionRight}>
                        <Text style={styles.titleRight}>Formação</Text>
                        {formData.formacao.map(form => (
                            <View key={form.id} style={styles.item}>
                                <View style={styles.itemHeader}>
                                    <Text style={styles.itemTitle}>{form.curso}</Text>
                                    <Text style={styles.itemDate}>{`${form.inicio_form} - ${form.fim_form}`}</Text>
                                </View>
                                <Text style={styles.itemSubTitle}>{form.instituicao}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.sectionRight}>
                        <Text style={styles.titleRight}>Experiências</Text>
                        {formData.experiencia.map(exp => (
                            <View key={exp.id} style={styles.item}>
                                <View style={styles.itemHeader}>
                                    <Text style={styles.itemTitle}>{exp.cargo}</Text>
                                    <Text style={styles.itemDate}>{`${exp.inicio_exp} - ${exp.fim_exp || 'Atual'}`}</Text>
                                </View>
                                <Text style={styles.itemSubTitle}>{exp.empresa}</Text>
                                <Text style={styles.itemDescription}>{exp.descricao_exp}</Text>
                            </View>
                        ))}
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default CurriculoPDF;